import React from 'react'

import BkFlowRoomCardMediaGallery from '../elements/gallery/BkFlowRoomCardMediaGallery'
import BkFlowFeaturedIcons from '../elements/icons/BkFlowRoomFeaturedIcons'
import BkFlowRoomCardDescriptionButtons from '../elements/BkFlowRoomCardDescriptionButtons'
import BkFlowRoomCardCondensedPriceButton from '../elements/condensed/BkFlowRoomCardCondensedPriceButton'

import _ from 'lodash'
import yn from 'yn'

if (process.env.REACT_APP_COMPONENT_ROOM_CARD_COMPONENT === 'condensed') {
	require('../../../styles/css/components/room/bk-flow-room-cards-condensed.css')
}

const BkFlowRoomCardCondensed = props => {
	const {
		cards,
		displayedPriceFrequency,
		fullScreenEvent,
		gallery,
		hotelLabels,
		imageClickEvent,
		isFullScreen,
		payPromoRoomRates,
		quantityNotifications,
		queriedRatePlan,
		queriedRoomRate,
		ratePlanData,
		renderFullScreenButton,
		roomDetailsAccordionEvent,
		roomDetailsAccordionExpanded,
		roomGroup,
		toggleActiveRoom,
		totalNights,
		totalRoomRates,
		unrefinedGuestRoom,
		urlData,
		virtualTourEvent,
	} = props

	let roomTypePriceButtons = []

	if (
		urlData &&
		urlData.ratePlanCode &&
		queriedRoomRate &&
		queriedRatePlan
	) {
		roomTypePriceButtons.push(
			<BkFlowRoomCardCondensedPriceButton
				key={'queried-room-rate-' +  queriedRoomRate.ratePlanCode }
				displayedPriceFrequency={displayedPriceFrequency}
				ratePlanData={queriedRatePlan}
				roomGroup={roomGroup}
				roomRateData={queriedRoomRate}
				toggleActiveRoom={toggleActiveRoom}
				totalNights={totalNights}
			/>
		)
	} else if (
		urlData &&
		urlData.promoCode &&
		!_.isEmpty(payPromoRoomRates)
	) {
		for (const rateKey in payPromoRoomRates) {
			const currentPromoRate = payPromoRoomRates[rateKey]

			if (
				currentPromoRate.roomRateData &&
				currentPromoRate.ratePlanData
			) {
				roomTypePriceButtons.push(
					<BkFlowRoomCardCondensedPriceButton
						key={'promo-room-rate-' + rateKey}
						displayedPriceFrequency={displayedPriceFrequency}
						ratePlanData={ currentPromoRate.ratePlanData }
						roomGroup={roomGroup}
						roomRateData={ currentPromoRate.roomRateData }
						toggleActiveRoom={toggleActiveRoom}
						totalNights={totalNights}
					/>
				)
			}
		}
	} else if (
		cards &&
		cards.viewExtensions &&
		cards.viewExtensions.roomRates
	) {
		const roomRates = cards.viewExtensions.roomRates

		for (const rateKey in roomRates) {
			const roomRate = roomRates[rateKey],
				roomRatePlan = ratePlanData.filter(function(rate) {
					return rate.ratePlanCode === roomRate.ratePlanCode
				})

			roomTypePriceButtons.push(
				<BkFlowRoomCardCondensedPriceButton
					key={'standard-room-rate-' + roomRate.ratePlanCode}
					displayedPriceFrequency={displayedPriceFrequency}
					ratePlanData={roomRatePlan[0]}
					roomGroup={roomGroup}
					roomRateData={roomRate}
					toggleActiveRoom={toggleActiveRoom}
					totalNights={totalNights}
				/>
			)
		}
	}

	return (
		<div
			id={ 'bk-flow-room__' + cards.roomTypeCode }
			key={ cards.roomTypeCode }
			className="bk-flow-room__card-entry row u-remove-padding"
		>
			<BkFlowRoomCardMediaGallery
				cards={cards}
				enableBullets={false}
				fullScreenEvent={fullScreenEvent}
				gallery={gallery}
				hotelLabels={hotelLabels}
				imageClickEvent={imageClickEvent}
				isFullScreen={isFullScreen}
				quantityNotifications={quantityNotifications}
				renderFullScreenButton={renderFullScreenButton}
				totalRoomRates={totalRoomRates}
				virtualTourEvent={virtualTourEvent}
			/>

			<div className="bk-flow-room__card-description">
				<div className="bk-flow-room__card-description__copy row">
					{ yn(process.env.REACT_APP_COMPONENT_BASE_CRS_DATA)
						&& !_.isEmpty(unrefinedGuestRoom) ?
						<h3>{ unrefinedGuestRoom[0].RoomTypeName }</h3>
					: cards.roomDescription.name ?
						<h3>{ cards.roomDescription.name }</h3>
					:
						null
					}

					{ yn(process.env.REACT_APP_COMPONENT_ROOM_FEATURED_ICONS) && <BkFlowFeaturedIcons roomGroup={ roomGroup } roomData={ cards } /> }
				</div>

				<div className="bk-flow-room__pricing row">
					{ !_.isEmpty(roomTypePriceButtons) && roomTypePriceButtons }
				</div>

				{ yn(process.env.REACT_APP_COMPONENT_ROOM_DETAILS_ACCORDION) &&
					<BkFlowRoomCardDescriptionButtons
						hotelLabels={ hotelLabels }
						isMobileButtons={ false }
						roomDetailsExpanded={ roomDetailsAccordionExpanded }
						handleRoomDetailsAccordion={ roomDetailsAccordionEvent }
					/>
				}
			</div>
		</div>
	)
}

export default BkFlowRoomCardCondensed


// WEBPACK FOOTER //
// ./src/components/room/layouts/BkFlowRoomCardCondensed.js